import React, { useCallback, useMemo, useState } from 'react'

import { useBreakpoints } from 'hooks'
import { apiManager } from 'helpers'
import { getStyles } from 'pages/admin/ForYouProfiles/styles'

import Profile from 'pages/admin/ForYouProfiles/Profile'
import EmptyState from 'pages/admin/ForYouProfiles/EmptyState'

const ForYouProfiles = ({ profiles, onReload, onAction, admin, children, indexToDisplay = 0 }) => {
  const { md } = useBreakpoints()
  const [currentIndex, setCurrentIndex] = useState(indexToDisplay)
  const styles = useMemo(() => getStyles(md), [md])

  const handleProfileLike = useCallback(() => {
    setCurrentIndex(index => index + 1)
  }, [])

  const handleReload = useCallback(async () => {
    if (!admin) {
      await apiManager.resetProfiles()
    }

    await onReload()
    setCurrentIndex(0)
  }, [admin, onReload])

  return (
    <div
      className="max-w-3xl mx-auto w-full relative h-screen-less-navbar-m md:h-screen-less-navbar"
      style={styles.profile}
    >
      {children}
      <div
        className="flex flex-col h-full w-full relative justify-center"
        style={styles.profileWrapper}
      >
        {currentIndex < profiles?.length ? (
          <Profile
            user={profiles[currentIndex]}
            md={md}
            onLike={handleProfileLike}
            onAction={onAction}
            key={profiles[currentIndex]?.id}
            admin={admin}
          />
        ) : (
          <EmptyState onReload={handleReload} md={md} admin={admin} />
        )}
      </div>
    </div>
  )
}

export default ForYouProfiles
